import { css } from "aphrodite";
import styles from "./styles";
import {Link, Typography} from "@mui/material";
import StepDataInfo from "../StepDataInfo/StepDataInfo";
import { useTranslation } from "react-i18next";
import { CustomMainButton } from "../CustomMainButton";
import FriendlyCaptcha from "../FriendlyCaptcha/FriendlyCaptcha";
import React from "react";
import Logger from "../../../../Utils/Logger";
import i18n from "../../../../i18n";

const CompleteCommonMobileLayout = ({
    title,
    subTitle,
    iconSrc = null,
    referenceNumber,
    description,
    setCaptcha,
    appointmentValuesVisible = false,
    appointmentData = null,
    secondaryButtonVisible = false,
    secondaryButtonTitle = "Edit again",
    secondaryButtonColor = "secondary",
    handleGoHome = () => {},
    secondaryButtonOnClick = () => {},
    link = '',
}) => {
    const [t] = useTranslation(["translation"]);
    const [isCaptchaResolved, setIsCaptchaResolved] = React.useState(false);

    const handleCaptchaSuccess = (solution) => {
        if (setCaptcha && typeof setCaptcha === "function") {
            setIsCaptchaResolved(true);
            setCaptcha(solution);
        }
    }
    const handleCaptchaFailure = () => {
        setIsCaptchaResolved(false);
        if (setCaptcha && typeof setCaptcha === "function") {
            setCaptcha(null);
        }
    }
    const handleCaptchaExpire = () => {
        setIsCaptchaResolved(false);
        Logger.log("Cancel appointment mobile captcha expired")
    }

    return (
        <div className={css(styles.container)}>
            {title &&
                <Typography variant="h3" className={css(styles.title)}>
                    {title}
                </Typography>
            }
            {(iconSrc || subTitle) && (
                <div className={css(styles.titleRow)}>
                    {iconSrc && <img alt="" src={iconSrc} className={css(styles.titleIcon)} />}
                    {subTitle && (
                        <Typography variant="h4" className={css(styles.subTitle)}>
                            {subTitle}
                        </Typography>
                    )}
                </div>
            )}
            {appointmentValuesVisible && <StepDataInfo appointmentData={appointmentData} />}
            {referenceNumber && (
                <>
                    <Typography
                        variant="h3"
                        className={css([styles.referenceNumberTitle])}
                    >
                        {t("Reference Number: ")}
                    </Typography>
                    <Typography variant="h2">{referenceNumber}</Typography>
                </>
            )}
            {description && (
                <Typography
                    variant="body1"
                    className={css([styles.alignStart, styles.description])}
                >
                    {description}
                </Typography>
            )}
            {link &&
                <div className={css(styles.descriptionContainer)}>
                    <Typography variant="body1" style={{ marginTop: '16px' }}>
                        {i18n.language === 'gr' 
                            ? <>Δείτε περισσότερες λεπτομέρειες για το ραντεβού σας, πατώντας{' '}<strong><Link href={link} target={'_blank'} rel={'noopener'} style={{ fontWeight: 'bold' }}>εδώ</Link></strong>.</>
                            : <>Click{' '}<strong><Link href={link} target={'_blank'} rel={'noopener'} style={{ fontWeight: 'bold' }}>here</Link></strong> to view more details about your appointment</>
                        }
                    </Typography>                    
                </div>}
            {setCaptcha &&
            <div className={css(styles.captchaContainer)}>
                <FriendlyCaptcha
                    onSuccess={handleCaptchaSuccess}
                    onFailure={handleCaptchaFailure}
                    onExpire={handleCaptchaExpire}
                />
            </div>}
            {secondaryButtonVisible && (
                <CustomMainButton
                    fixedSize={false}
                    value={secondaryButtonTitle}
                    color={secondaryButtonColor}
                    textColor="white"
                    style={[styles.mobileButton]}
                    onClick={secondaryButtonOnClick}
                    isDisabled={!isCaptchaResolved}
                />
            )}
            <CustomMainButton
                fixedSize={false}
                value={t("Back to Home")}
                textColor="inherit"
                style={[styles.mobileButton, styles.gap]}
                onClick={handleGoHome}
            />
        </div>
    );
};

export default CompleteCommonMobileLayout;
